import { render, staticRenderFns } from "./KeywordsList.vue?vue&type=template&id=2f8db522"
import script from "./KeywordsList.vue?vue&type=script&lang=js"
export * from "./KeywordsList.vue?vue&type=script&lang=js"
import style0 from "./KeywordsList.vue?vue&type=style&index=0&id=2f8db522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports